<template>
  <!-- « FORFAIT » — an offer that also sells other job types. One dot per type
       it sells (its own first), then the word. Every offer menu draws the same
       mark, so a forfait reads the same on the type page, the job page, the
       intake, the grouped dialog, the desk and the phone. -->
  <span
    class="inline-flex shrink-0 items-center gap-1 rounded-full border px-1.5 py-px text-[11px] font-medium text-muted-foreground"
    data-testid="forfait-badge"
  >
    <TypeDot v-for="id in dotIds" :key="id" :color="typeColor(id)" />
    {{ t('proposals.forfait.badge') }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import TypeDot from '@/components/shared/TypeDot.vue'
import { typeColor } from '@/lib/typeIdentity'
import type { BundledType } from '@/lib/typeOffers'

const props = defineProps<{
  /** The offer's OWN type, when the caller knows it — its dot leads. */
  ownTypeId?: string | null
  bundledTypes: BundledType[]
}>()

const { t } = useI18n()

const dotIds = computed(() => [
  ...(props.ownTypeId ? [ props.ownTypeId ] : []),
  ...props.bundledTypes.map(b => b.id).filter(id => id !== props.ownTypeId),
])
</script>
